import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

// Icons
import IosShareIcon from '@mui/icons-material/IosShare';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SummarizeIcon from '@mui/icons-material/Summarize';

import Einvoice from "./einvoice";
import EinvoicePreValidation from './EinvoicePreValidation';
import Summary from './Summary';
import EinvoiceDashBoard from './EinvoiceDashBoard';


export default function ArcEInvoice() {
    const history = useHistory();
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0);
    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    
    const eInvoiceAccess = sitemapData?.EINVOICE || [];

    const eInvoiceTabs = [
        eInvoiceAccess && {
            label: 'Uploads',
            icon: <IosShareIcon />,
            path: '/einvoice/company',
            component: <Einvoice />
        },
        eInvoiceAccess && {
            label: 'Pre-Validation',
            icon: <FactCheckIcon />,
            path: '/EinvoicePreValidation',
            component: <EinvoicePreValidation />
        },
        eInvoiceAccess && {
            label: 'Summary',
            icon: <SummarizeIcon />,
            path: '/Summary',
            component: <Summary />
        },
        eInvoiceAccess && {
            label: 'DashBoard',
            icon: <DashboardIcon />,
            path: '/EinvoiceDashBoard',
            component: <EinvoiceDashBoard />
        }
    ].filter(Boolean);

    useEffect(() => {
        if (!eInvoiceTabs.length) return;

        const foundIndex = eInvoiceTabs.findIndex(tab => location.pathname === tab.path);

        if (foundIndex !== -1) {
            setTabIndex(foundIndex);
        } else {
            setTabIndex(0);
            history.replace(eInvoiceTabs[0].path);
        }
    }, [location.pathname, eInvoiceTabs, history]);


    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        const selectedTab = eInvoiceTabs[newValue];
        if (selectedTab?.path) {
            console.log("Navigation path............", selectedTab)
            history.push(selectedTab.path);
        }
    };

    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
            {/* Toggle Button Group */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                    mb: 4,
                }}
            >
                {eInvoiceTabs.length > 0 ? (
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="Sales/Purchase Tabs"
                        sx={{
                            backgroundColor: '#ffffff',
                            borderRadius: '30px',
                            p: '4px',
                            maxWidth: '80%',
                            overflowX: 'auto',
                            '.MuiTab-root': {
                                width:'auto',
                                textTransform: 'uppercase',
                                fontWeight: 550,
                                fontFamily: '"Dosis", sans-serif',
                                letterSpacing: '1px',
                                fontSize: '13px',
                                minHeight: '35px',
                                borderRadius: '20px',
                                px: 2.5,
                                py: 0.9,
                                color: '#212121',
                                '&:hover': {
                                    backgroundColor: 'var(--sub-btn-color)',
                                    color: '#fff !important',
                                },
                            },
                            '.Mui-selected': {
                                backgroundColor: 'var(--sub-btn-color)',
                                color: '#fff !important',
                            },
                            '.MuiTabs-indicator': {
                                display: 'none',
                            },
                            '.MuiTabs-scrollButtons': {
                                backgroundColor: '#64b5f6',
                                borderRadius: '50%',
                                '&.Mui-disabled': {
                                  opacity: 0.3,
                                },
                              },
                        }}
                    >
                        {eInvoiceTabs.map((tab, index) => (
                            <Tab key={index} icon={tab.icon} iconPosition="start" label={tab.label} />
                        ))}
                    </Tabs>
                ) : null}
            </Box>

            {/* Content or Empty Message */}
            {eInvoiceTabs.length > 0 ? (
                <Box>{eInvoiceTabs[tabIndex]?.component}</Box>
            ) : (
                <Box
                    sx={{
                        textAlign: 'center',
                        mt: 20,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                    <Box sx={{ fontSize: '18px', color: '#607d8b', fontFamily: '"Dosis", sans-serif', }}>
                        Please activate the E-INVOICE Services to access.
                    </Box>
                </Box>
            )}
        </Box>
    );
}      
